/**
 * Configuration centralisée de l'application
 */

export const config = {
  // API
  API_URL: process.env.REACT_APP_API_URL || '/api',
  API_BASE_URL: process.env.REACT_APP_API_URL?.replace('/api', '') || '',
  
  // Upload
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
  
  // Pagination
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  
  // Timeouts
  API_TIMEOUT: 30000, // 30 secondes
  SCRAPING_TIMEOUT: 180000, // 3 minutes
  
  // Toast
  TOAST_DURATION: {
    SUCCESS: 3000,
    ERROR: 5000,
    WARNING: 4000,
    INFO: 3000,
  },
  
  // Formats
  DATE_FORMAT: 'DD/MM/YYYY',
  TIME_FORMAT: 'HH:mm',
  DATETIME_FORMAT: 'DD/MM/YYYY HH:mm',
  
  // Contact (e-mail : surcharge possible REACT_APP_CONTACT_EMAIL ou REACT_APP_SUPPORT_EMAIL)
  CONTACT_EMAIL:
    (process.env.REACT_APP_CONTACT_EMAIL || process.env.REACT_APP_SUPPORT_EMAIL || '')
      .trim() || 'contact@maxyfly.shop',

  // Numéros (liens tel:)
  CONTACT_PHONES: [
    { tel: '+243900765856', display: '+243 900 765 856' },
    { tel: '+243837481036', display: '+243 837 481 036' },
    { tel: '+243971091126', display: '+243 971 091 126' },
  ],

  // Validation
  MIN_PASSWORD_LENGTH: 6,
  PHONE_REGEX: /^243\d{9}$/,
  
  // Features
  ENABLE_DARK_MODE: true,
  ENABLE_NOTIFICATIONS: true,
  ENABLE_CHAT: true,

  // Boutique locale
  LOCAL_DELIVERY_FEE: Number(process.env.REACT_APP_LOCAL_DELIVERY_FEE) || 35,
};





